/* One contrast colour per slide; the curved image edge is the only text split. */
(()=>{
for(const hero of document.querySelectorAll('.dc-origen .hero')){
 const media=hero.querySelector('.hero-media'),overlay=hero.querySelector('.hero-contrast');
 if(!media||!overlay)continue;
 const cache=new Map();let frame;
 function useWhite(slide){
  if(slide.classList.contains('hero-logo-slide'))return false;
  const img=slide.matches('img')?slide:slide.querySelector('img');
  if(!img?.complete||!img.naturalWidth)return false;
  const box=media.getBoundingClientRect(),key=[img.currentSrc,Math.round(box.width),Math.round(box.height)].join('|');
  if(cache.has(key))return cache.get(key);
  try{
   const c=document.createElement('canvas');c.width=80;c.height=Math.round(c.width*box.height/box.width);
   const ctx=c.getContext('2d',{willReadFrequently:true});ctx.fillStyle='#fff';ctx.fillRect(0,0,c.width,c.height);
   const scale=Math.max(c.width/img.naturalWidth,c.height/img.naturalHeight),w=img.naturalWidth*scale,h=img.naturalHeight*scale;
   const pos=getComputedStyle(img).objectPosition.split(' '),px=parseFloat(pos[0])/100||.5,py=parseFloat(pos[1])/100||.5;
   ctx.drawImage(img,(c.width-w)*px,(c.height-h)*py,w,h);
   const d=ctx.getImageData(0,0,c.width,c.height).data;let sum=0,count=0;
   const linear=v=>{v/=255;return v<=.04045?v/12.92:((v+.055)/1.055)**2.4};
   for(let y=0;y<c.height;y++)for(let x=0;x<c.width;x++){
    if(((x/c.width-1)/.78)**2+((y/c.height-.5)/.70)**2>1)continue;
    const i=(y*c.width+x)*4;sum+=.2126*linear(d[i])+.7152*linear(d[i+1])+.0722*linear(d[i+2]);count++;
   }
   // Prefer white on photos; switch to black only for a clearly pale background.
   const white=count>0&&sum/count<.72;cache.set(key,white);return white;
  }catch{return false;}
 }
 function update(){const active=media.querySelector('.is-active');if(active)overlay.style.opacity=useWhite(active)?'1':'0';}
 function prepare(){for(const slide of media.children)useWhite(slide);update();}
 for(const img of media.querySelectorAll('img')){img.loading='eager';img.addEventListener('load',prepare);}
 new MutationObserver(update).observe(media,{subtree:true,attributes:true,attributeFilter:['class']});
 new ResizeObserver(()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(prepare);}).observe(media);
 prepare();
}
})();
